import axios from "axios";
import { SkillMastar } from "./dto/Skill";

// スキルマスタ情報取得
export const getSkills = async (): Promise<SkillMastar[]> => {
  const res = await axios.get<SkillMastar[]>(`/api/skill`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};